<template>
    <div class="d-flex flex-column width-max-600 mx-auto pt-4 pb-5">
        <h2><b-badge variant="light" class="rounded"><feather type="bell" /></b-badge></h2>
        <h4>{{ $t('addYourFirstSpace') }}</h4>
        <p class="font-size-16">{{ $t('addYourFirstSpaceDescription') }}</p>
        <ButtonIcon icon="plus" class="mr-auto" @click="$router.push({ name: 'Pages' })">{{ $t('addWebsite') }}</ButtonIcon>
    </div>
</template>



<script>
    export default {
        name: 'AddFirstSpace',
    };
</script>
